import { getStoredAccessToken, getStoredRefreshToken, persistTokenPair } from './api/authTokens';

/** Clé de l'utilisateur de la session Ligue (celle de MySquash), lue par league/auth/AuthContext.js. */
export const LEAGUE_USER_KEY = 'mysquash.user';

/** Vrai si une session de la Ligue est déjà ouverte dans ce navigateur (même origine). */
export function hasLeagueSession() {
  try {
    return Boolean(localStorage.getItem(LEAGUE_USER_KEY) && (getStoredAccessToken() || getStoredRefreshToken()));
  } catch {
    return false;
  }
}

/**
 * ERP d'un club → espace Ligue sans reconnexion : adopte comme session de la Ligue une réponse de
 * `POST /Player/auth/switch_club` (nouvelle session indépendante de celle de l'ERP : jamais le même jeton de
 * rafraîchissement dans les deux espaces). L'espace Ligue vérifie ensuite `GET /League/me` comme à chaque ouverture.
 * Retourne true si la session est enregistrée.
 */
export function adoptLeagueSession(data) {
  if (!persistTokenPair(data)) return false;
  const u = data?.user ?? {};
  try {
    localStorage.setItem(
      LEAGUE_USER_KEY,
      JSON.stringify({ id: u.id, email: u.email, firstName: u.first_name, lastName: u.last_name, picture: u.picture }),
    );
  } catch {
    return false;
  }
  return true;
}
